export default "__VITE_ASSET__KbDXSDGi__"